export const setCookie = (name: string, val: string) => {
  const date = new Date();
  const value = val;

  // Set it expire in 14 days
  date.setTime(date.getTime() + 14 * 24 * 60 * 60 * 1000);
  // Set it
  document.cookie =
    name + '=' + value + '; expires=' + date.toUTCString() + '; path=/';
  const div = document.getElementById('ccpa-notice');
  if (div != null) {
    div.style.display = 'none';
  }
};

export const getCookie = (cname: string) => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const checkCookie = () => {
  //alert(getCookie("priv3"));
  if (getCookie('priv3') === 'yes') {
    const div = document.getElementById('ccpa-notice');
    if (div != null) {
      div.style.display = 'none';
      //      alert("cookie!");
    }
  }
};
